import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import API_DE from './src/locale/de/api.json';
import CAMPAIGNS_DE from './src/locale/de/campaigns.json';
import COMMON_DE from './src/locale/de/common.json';
import USERS_DE from './src/locale/de/users.json';
import API_EN from './src/locale/en/api.json';
import CAMPAIGNS_EN from './src/locale/en/campaigns.json';
import COMMON_EN from './src/locale/en/common.json';
import USERS_EN from './src/locale/en/users.json';
import API_ES from './src/locale/es/api.json';
import CAMPAIGNS_ES from './src/locale/es/campaigns.json';
import COMMON_ES from './src/locale/es/common.json';
import USERS_ES from './src/locale/es/users.json';
import API_IT from './src/locale/it/api.json';
import CAMPAIGNS_IT from './src/locale/it/campaigns.json';
import COMMON_IT from './src/locale/it/common.json';
import USERS_IT from './src/locale/it/users.json';
import { LocalStorageKeys } from './src/shared/consts/localStorageKeys.ts';
import { bindDocumentHeadToI18n } from './src/shared/utils/applyDocumentHead.ts';

const resources = {
  en: {
    common: COMMON_EN,
    campaigns: CAMPAIGNS_EN,
    users: USERS_EN,
    api: API_EN,
  },
  it: {
    common: COMMON_IT,
    campaigns: CAMPAIGNS_IT,
    users: USERS_IT,
    api: API_IT,
  },
  es: {
    common: COMMON_ES,
    campaigns: CAMPAIGNS_ES,
    users: USERS_ES,
    api: API_ES,
  },
  de: {
    common: COMMON_DE,
    campaigns: CAMPAIGNS_DE,
    users: USERS_DE,
    api: API_DE,
  },
};

await i18n.use(initReactI18next).init({
  debug: false,
  resources,
  // TODO: create global controller for handling storage
  lng: localStorage.getItem(LocalStorageKeys.LANGUAGE) || 'it',
  fallbackLng: 'it',
  interpolation: { escapeValue: false },
  react: {
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'span', 'strong', 'i'],
    useSuspense: true,
  },
});

bindDocumentHeadToI18n(i18n);
